import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/signin/icon_vip.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b52809d8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "header"
};
var _hoisted_2 = {
  "class": "title"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  "class": "collapse-header flex-start"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  "class": "title"
};
var _hoisted_8 = {
  style: {}
};
var _hoisted_9 = {
  "class": "header-box"
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  key: 0,
  "class": "item-year-tips"
};
var _hoisted_12 = {
  key: 1,
  "class": "item-year-tips"
};
var _hoisted_13 = {
  key: 2,
  "class": "item-year-tips"
};
var _hoisted_14 = {
  key: 0,
  "class": "textBox"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  key: 0,
  style: {
    "display": "flex"
  },
  "class": "price"
};
var _hoisted_17 = {
  key: 0,
  "class": "original-cost"
};
var _hoisted_18 = {
  key: 1
};
var _hoisted_19 = {
  key: 2
};
var _hoisted_20 = {
  key: 3
};
var _hoisted_21 = {
  key: 1,
  "class": "price mlauto"
};
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "$0.00", -1);
});
var _hoisted_23 = [_hoisted_22];
var _hoisted_24 = {
  key: 1,
  "class": "textBox"
};
var _hoisted_25 = {
  key: 0,
  "class": "text"
};
var _hoisted_26 = {
  key: 1,
  "class": "text"
};
var _hoisted_27 = {
  key: 2,
  "class": "text"
};
var _hoisted_28 = {
  key: 1,
  "class": "textBox"
};
var _hoisted_29 = {
  key: 0
};
var _hoisted_30 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
var _hoisted_31 = {
  key: 0,
  "class": "original-cost"
};
var _hoisted_32 = {
  key: 1,
  "class": "price"
};
var _hoisted_33 = {
  key: 0
};
var _hoisted_34 = {
  key: 1
};
var _hoisted_35 = {
  key: 2
};
var _hoisted_36 = {
  key: 2,
  "class": "price mlauto"
};
var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "$0.00", -1);
});
var _hoisted_38 = [_hoisted_37];
var _hoisted_39 = {
  key: 1,
  "class": "textBox"
};
var _hoisted_40 = {
  key: 0,
  "class": "text"
};
var _hoisted_41 = {
  key: 1,
  "class": "text"
};
var _hoisted_42 = {
  key: 2,
  "class": "text"
};
var _hoisted_43 = {
  key: 2,
  "class": "un-support-tips"
};
var _hoisted_44 = {
  key: 0,
  "class": "register-box"
};
var _hoisted_45 = {
  "class": "item"
};
var _hoisted_46 = {
  "class": "flex"
};
var _hoisted_47 = {
  "class": "item-option mar-box"
};
var _hoisted_48 = {
  "class": "flex"
};
var _hoisted_49 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_50 = {
  key: 0,
  "class": "item"
};
var _hoisted_51 = {
  "class": "flex"
};
var _hoisted_52 = {
  "class": "item-option"
};
var _hoisted_53 = {
  "class": "mo-input--number mb10"
};
var _hoisted_54 = {
  key: 0,
  "class": "define-append"
};
var _hoisted_55 = {
  key: 1,
  "class": "define-append"
};
var _hoisted_56 = {
  key: 1,
  "class": "register-box"
};
var _hoisted_57 = {
  "class": "item"
};
var _hoisted_58 = {
  "class": "flex"
};
var _hoisted_59 = {
  "class": "item-option"
};
var _hoisted_60 = {
  "class": "text"
};
var _hoisted_61 = {
  key: 1,
  "class": "register-box"
};
var _hoisted_62 = {
  "class": "item"
};
var _hoisted_63 = {
  "class": "flex"
};
var _hoisted_64 = {
  "class": "item-option mar-box"
};
var _hoisted_65 = {
  "class": "text"
};
var _hoisted_66 = {
  "class": "register-box coll-pop"
};
var _hoisted_67 = {
  "class": "item mbo"
};
var _hoisted_68 = {
  "class": "select-box-item"
};
var _hoisted_69 = {
  "class": "select-label"
};
var _hoisted_70 = {
  "class": "select-label"
};
var _hoisted_71 = {
  key: 0,
  "class": "right-box"
};
var _hoisted_72 = {
  key: 1,
  "class": "right-box"
};
var _hoisted_73 = {
  key: 0,
  "class": "code-error-box"
};
var _hoisted_74 = {
  key: 0,
  "class": "item-option"
};
var _hoisted_75 = {
  key: 0,
  "class": "number"
};
var _hoisted_76 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "-", -1);
});
var _hoisted_77 = {
  key: 1,
  "class": "number"
};
var _hoisted_78 = {
  key: 0
};
var _hoisted_79 = {
  key: 1
};
var _hoisted_80 = {
  key: 1
};
var _hoisted_81 = {
  "class": "item-buy"
};
var _hoisted_82 = {
  key: 1
};
var _hoisted_83 = {
  "class": "item-price"
};
var _hoisted_84 = {
  "class": "price"
};
var _hoisted_85 = {
  "class": "item-fee"
};
var _hoisted_86 = {
  key: 1
};
var _hoisted_87 = {
  key: 2,
  "class": "item-flex"
};
var _hoisted_88 = {
  key: 0,
  "class": "disabled-text"
};
var _hoisted_89 = {
  key: 3,
  id: "recaptcha",
  "class": "flex-end",
  style: {
    "margin-top": "0.8rem"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$currencySelect;
  var _component_el_tooltip = _resolveComponent("el-tooltip");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_input_number = _resolveComponent("el-input-number");
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");
  var _component_el_collapse = _resolveComponent("el-collapse");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_input = _resolveComponent("el-input");
  var _component_empty = _resolveComponent("empty");
  var _component_currency_select = _resolveComponent("currency-select");
  var _component_gasNumber = _resolveComponent("gasNumber");
  var _component_numberSkeleton = _resolveComponent("numberSkeleton");
  var _component_registerLoad = _resolveComponent("registerLoad");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createTextVNode(_toDisplayString(_ctx.$t("ShoppingCart.title")) + " ", 1), $options.registerNumber($data.shopCartList) > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString($options.registerNumber($data.shopCartList)) + ") ", 1)) : _createCommentVNode("", true)]), _createVNode(_component_el_tooltip, {
    "class": "box-item",
    effect: "dark",
    content: _ctx.$t('ShoppingCart.close'),
    placement: "top"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("i", {
        "class": "icon",
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.handRemoveAll && $options.handRemoveAll.apply($options, arguments);
        })
      })];
    }),
    _: 1
  }, 8, ["content"]), _createElementVNode("i", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.handleClosesBox(1);
    }),
    "class": "close"
  })]), $data.shopCartList.length > 0 && !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_collapse, {
    ref: "collapse",
    modelValue: $data.activeNames,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.activeNames = $event;
    }),
    accordion: "",
    "class": _normalizeClass(["coll-buy-item", {
      active: _ctx.registerLoading,
      'coll-buy': _ctx.disabledBtn(_ctx.balancewallect, _ctx.usePriceExpen)
    }]),
    id: "coll-buy-item",
    onChange: _cache[3] || (_cache[3] = function ($event) {
      return $options.handleChange($event);
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shopCartList, function (item, i) {
        return _openBlock(), _createBlock(_component_el_collapse_item, {
          key: i,
          name: i,
          "class": _normalizeClass("coll-collapse".concat(i)),
          disabled: item.domainStatus != '0' || item.protectFlag && !item.whitelistAddr || item.protectFlag && item.whitelistAddr && item.whitelistAddr.toLowerCase() != _ctx.$store.state.account.toLowerCase() || $options.isUnSupport(item.registerChainIds).status || !item.showList
        }, {
          title: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tooltip, {
              "class": "box-item",
              effect: "dark",
              content: _ctx.$t('publish.delete'),
              placement: "top"
            }, {
              "default": _withCtx(function () {
                return [_createElementVNode("i", {
                  "class": "remove",
                  onClick: _withModifiers(function ($event) {
                    return $options.handRemove(i, item);
                  }, ["stop"])
                }, null, 8, _hoisted_6)];
              }),
              _: 2
            }, 1032, ["content"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tooltip, {
              "class": "box-item",
              effect: "dark",
              content: item.name,
              disabled: item.name.length < 25,
              placement: "top"
            }, {
              "default": _withCtx(function () {
                return [_createElementVNode("span", _hoisted_8, _toDisplayString($options.name(item.name)), 1)];
              }),
              _: 2
            }, 1032, ["content", "disabled"])]), _createElementVNode("div", _hoisted_9, [!item.is_free && item.domainStatus == 0 && !item.protectFlag && !$options.isUnSupport(item.registerChainIds).status || !item.is_free && item.domainStatus == 0 && item.protectFlag && item.whitelistAddr && item.whitelistAddr.toLowerCase() == _ctx.$store.state.account.toLowerCase() && !$options.isUnSupport(item.registerChainIds).status ? (_openBlock(), _createElementBlock("div", _hoisted_10, [item.way_status == 1 && item.num == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.num) + " " + _toDisplayString(_ctx.$t("ShoppingCart.m_year")), 1)) : item.way_status == 1 && item.num > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.num) + " " + _toDisplayString(_ctx.$t("ShoppingCart.m_years")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("ShoppingCart.buy_out")), 1))])) : _createCommentVNode("", true)]), !item.protectFlag ? (_openBlock(), _createElementBlock("div", _hoisted_14, [item.domainStatus == '0' && !$options.isUnSupport(item.registerChainIds).status ? (_openBlock(), _createElementBlock("div", _hoisted_15, [!item.is_free ? (_openBlock(), _createElementBlock("div", _hoisted_16, [item.priceDiscount && Number(item.priceDiscount) != 1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "$" + _toDisplayString($options.getOriginalPrice(item.priceDiscount, item.way_status == 2 ? _ctx.calculate(item.buyOut, "", 2, "num") : _ctx.calculate(item.price, item.num, 2, "m"))), 1)) : _createCommentVNode("", true), item.way_status == 1 && Number(item.firstYearFreeFlag) > 0 && !item.protectFlag || item.way_status == 1 && Number(item.firstYearFreeFlag) == 1 && item.protectFlag ? (_openBlock(), _createElementBlock("span", _hoisted_18, " $" + _toDisplayString(_ctx.calculate(item.price, Number(item.num) - 1, 2, "m")), 1)) : item.way_status == 1 && Number(item.firstYearFreeFlag) == 0 && !item.protectFlag ? (_openBlock(), _createElementBlock("span", _hoisted_19, " $" + _toDisplayString(_ctx.calculate(item.price, item.num, 2, "m")), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_20, " $" + _toDisplayString(_ctx.calculate(item.buyOut, "", 2, "num")), 1))])) : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))])) : item.domainStatus != '0' || $options.isUnSupport(item.registerChainIds).status ? (_openBlock(), _createElementBlock("div", _hoisted_24, [item.domainStatus == 1 || item.domainStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("ShoppingCart.registered")), 1)) : $options.isUnSupport(item.registerChainIds).status ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("ShoppingCart.unsupported_chain")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("ShoppingCart.unavailable")), 1))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [item.domainStatus == 0 && item.firstYearFreeFlag == 1 || item.domainStatus == 0 && item.whitelistAddr && item.whitelistAddr.toLowerCase() == _ctx.$store.state.account.toLowerCase() && !$options.isUnSupport(item.registerChainIds).status ? (_openBlock(), _createElementBlock("div", _hoisted_29, [item.domainStatus == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [item.priceDiscount && Number(item.priceDiscount) != 1 ? (_openBlock(), _createElementBlock("span", _hoisted_31, "$" + _toDisplayString($options.getOriginalPrice(item.priceDiscount, item.way_status == 2 ? _ctx.calculate(item.buyOut, "", 2, "num") : _ctx.calculate(item.price, item.num, 2, "m"))), 1)) : _createCommentVNode("", true), !item.is_free ? (_openBlock(), _createElementBlock("div", _hoisted_32, [item.way_status == 1 && Number(item.firstYearFreeFlag) > 0 || item.way_status == 1 && Number(item.firstYearFreeFlag) == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_33, " $" + _toDisplayString(_ctx.calculate(item.price, Number(item.num) - 1, 2, "m")), 1)) : item.way_status == 1 && Number(item.firstYearFreeFlag) == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_34, " $" + _toDisplayString(_ctx.calculate(item.price, item.num, 2, "m")), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_35, " $" + _toDisplayString(_ctx.calculate(item.buyOut, "", 2, "num")), 1))])) : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_39, [item.domainStatus == 1 || item.domainStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t("ShoppingCart.registered")), 1)) : $options.isUnSupport(item.registerChainIds).status ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t("ShoppingCart.unsupported_chain")), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t("ShoppingCart.unavailable")), 1))]))])), (item.domainStatus == '0' && !$options.isUnSupport(item.registerChainIds).status && !item.protectFlag || item.domainStatus == 0 && item.firstYearFreeFlag == 1 || item.domainStatus == 0 && item.whitelistAddr && item.whitelistAddr.toLowerCase() == _ctx.$store.state.account.toLowerCase() && !$options.isUnSupport(item.registerChainIds).status && item.protectFlag) && !item.showList ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t("ShoppingCart.un_support_payments1")) + " " + _toDisplayString(_ctx.currencySelect.tokenName) + " " + _toDisplayString(_ctx.$t("ShoppingCart.un_support_payments2")) + _toDisplayString(_ctx.getSupportName(item)), 1)) : _createCommentVNode("", true)])];
          }),
          "default": _withCtx(function () {
            return [!item.is_free ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [item.registerPeriod == 1 || !item.registerPeriod ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: function onClick($event) {
                return $options.handSelect(i, 1);
              },
              color: "#FCFEFE",
              "class": _normalizeClass(item.way_status == 1 ? 'active' : '')
            }, {
              "default": _withCtx(function () {
                return [_createTextVNode(_toDisplayString(_ctx.$t("ShoppingCart.year")), 1)];
              }),
              _: 2
            }, 1032, ["onClick", "class"])) : _createCommentVNode("", true), item.registerPeriod == 2 || !item.registerPeriod ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              onClick: function onClick($event) {
                return $options.handSelect(i, 2);
              },
              "class": _normalizeClass([item.way_status == 2 ? 'active' : '', "ml20"]),
              color: "#FCFEFE"
            }, {
              "default": _withCtx(function () {
                return [_hoisted_49, _createTextVNode(_toDisplayString(_ctx.$t("ShoppingCart.buy_out")), 1)];
              }),
              _: 2
            }, 1032, ["onClick", "class"])) : _createCommentVNode("", true)])])])]), item.way_status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createVNode(_component_el_input_number, {
              modelValue: item.num,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.num = $event;
              },
              min: 1,
              onChange: $options.handleChangeYear
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), item.num == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.$t("ShoppingCart.m_year")), 1)) : item.num > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.$t("ShoppingCart.m_years")), 1)) : _createCommentVNode("", true)])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("ShoppingCart.hold_for_life")), 1)])])])]))])) : (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("ShoppingCart.hold_for_life")), 1)])])])]))];
          }),
          _: 2
        }, 1032, ["name", "class", "disabled"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "class"]), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createVNode(_component_el_select, {
    modelValue: $data.nowActive,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.nowActive = $event;
    }),
    "popper-class": "select-opt",
    "class": _normalizeClass(["left-box", !_ctx.showInvite ? 'disabled-box' : '']),
    placeholder: "Select",
    size: "large",
    ref: "select-card",
    disabled: !_ctx.showInvite,
    onVisibleChange: $options.visibleChange,
    onFocus: $options.focusBox,
    onChange: $options.handleType
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        label: _ctx.$t('signin.invitation_code'),
        value: 1
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("signin.invitation_code")), 1)];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_option, {
        label: _ctx.$t('signin.coupon'),
        value: 2
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t("signin.coupon")), 1)];
        }),
        _: 1
      }, 8, ["label"])];
    }),
    _: 1
  }, 8, ["modelValue", "class", "disabled", "onVisibleChange", "onFocus", "onChange"]), $data.nowActive == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_createVNode(_component_el_input, {
    modelValue: _ctx.invitationCode,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return _ctx.invitationCode = $event;
    }),
    disabled: _ctx.sessInvitationCode != '',
    "class": _normalizeClass(_ctx.sessInvitationCode != '' ? 'has-value' : ''),
    onBlur: _cache[6] || (_cache[6] = function ($event) {
      return $data.searchStatus = false;
    }),
    onFocus: _cache[7] || (_cache[7] = function ($event) {
      return $data.searchStatus = true;
    }),
    placeholder: !$data.searchStatus ? "".concat(_ctx.$t('signin.tips')) : ''
  }, null, 8, ["modelValue", "disabled", "class", "placeholder"])])) : (_openBlock(), _createElementBlock("div", _hoisted_72, [_createVNode(_component_el_select, {
    modelValue: $data.couponList,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return $data.couponList = $event;
    }),
    "popper-class": "coupon-popper-select",
    "class": "coupon-select",
    multiple: "",
    "collapse-tags": "",
    "collapse-tags-tooltip": "",
    "popper-append-to-body": false,
    placeholder: _ctx.$t('ShoppingCart.coupon_placeholder'),
    size: "large",
    onChange: $options.handChange,
    ref: "select-card1",
    onVisibleChange: $options.visibleChange,
    onFocus: _cache[9] || (_cache[9] = function ($event) {
      return $options.focusBox(1);
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceList, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.label,
          value: item.id,
          disabled: _ctx.disabledSel(item, 1)
        }, null, 8, ["label", "value", "disabled"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "placeholder", "onChange", "onVisibleChange"])]))]), _ctx.inviteStatus == 3 && _ctx.invitationCode ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_ctx.$t("signin.code_error")), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
    "class": _normalizeClass(["flex item-position", _ctx.invitationCode && _ctx.inviteStatus == 2 ? 'posi-box' : ''])
  }, [_ctx.invitationCode || $data.couponList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_74, [!_ctx.invitationCode && $data.nowActive == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_75, [_hoisted_76, _createTextVNode("$" + _toDisplayString($options.getCouponPrice()), 1)])) : _ctx.invitationCode && _ctx.inviteStatus == 2 && $data.nowActive == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_77, [1 - _ctx.inviteeDiscount > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_78, "(" + _toDisplayString(_ctx.$t("ShoppingCart.discount")) + _toDisplayString(((1 - _ctx.inviteeDiscount) * 100).toFixed(0)) + "%" + _toDisplayString(_ctx.$t("ShoppingCart.discount1")) + ")", 1)) : _createCommentVNode("", true), _ctx.calculate($data.originalPrice, Number($data.price), 2, 's') > 0 ? (_openBlock(), _createElementBlock("b", _hoisted_79, "-")) : _createCommentVNode("", true), _createTextVNode("$" + _toDisplayString(_ctx.calculate($data.originalPrice, Number($data.price), 2, "s")), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2)])])])) : !$data.loading && $data.shopCartList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_createVNode(_component_empty, {
    image: $data.images,
    emptyStr: ""
  }, null, 8, ["image"])])) : _createCommentVNode("", true), $data.registerPayMethod ? (_openBlock(), _createBlock(_component_currency_select, {
    key: 2,
    isCard: true,
    registerPayMethod: $data.registerPayMethod,
    onSelectChange: $options.currencySelectChange
  }, null, 8, ["registerPayMethod", "onSelectChange"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_81, [$data.shopCartList.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(["gas-price", _ctx.invitationCode && _ctx.inviteStatus == 2 || $data.couponList.length > 0 ? 'mt0' : ''])
  }, [_createTextVNode(_toDisplayString(_ctx.$t("ShoppingCart.estimated_gas")) + ":", 1), _createVNode(_component_gasNumber, {
    usdPrice: _ctx.gasPrice
  }, null, 8, ["usdPrice"])], 2)) : _createCommentVNode("", true), $data.shopCartList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, _toDisplayString((_ctx$currencySelect = _ctx.currencySelect) !== null && _ctx$currencySelect !== void 0 && _ctx$currencySelect.chainId ? _ctx.$t("signin.cost") : _ctx.$t("signin.total_cost")) + ": ", 1), $options.registerNumber($data.shopCartList) > 0 ? (_openBlock(), _createBlock(_component_numberSkeleton, {
    key: 0,
    currencySelect: _ctx.currencySelect,
    priceOg: $data.price,
    price: _ctx.usdtPariceNum,
    usdPrice: _ctx.usdPrice
  }, null, 8, ["currencySelect", "priceOg", "price", "usdPrice"])) : (_openBlock(), _createElementBlock("span", _hoisted_86, "$0.00"))])])])) : _createCommentVNode("", true), $data.shopCartList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_ctx.disabledBtn(_ctx.balancewallect, _ctx.usePriceExpen) ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_ctx.$t("publish.wallect_insufficient")), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    disabled: $options.registerNumber($data.shopCartList) == 0 || _ctx.disabledBtn(_ctx.balancewallect, _ctx.usePriceExpen),
    "class": _normalizeClass([$options.registerNumber($data.shopCartList) == 0 ? 'disabled' : '', "svgDisnone"]),
    style: _normalizeStyle(_ctx.disabledBtn(_ctx.balancewallect, _ctx.usePriceExpen) ? 'margin-left:0.8rem;opacity: 0.7;' : 'margin-left:auto'),
    loading: _ctx.registerLoading,
    color: "#000",
    onClick: $options.handleRegisterBox,
    type: "primary"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("ShoppingCart.register")), 1)];
    }),
    _: 1
  }, 8, ["disabled", "class", "style", "loading", "onClick"])])) : _createCommentVNode("", true), _ctx.recaptchaVisible ? (_openBlock(), _createElementBlock("div", _hoisted_89)) : _createCommentVNode("", true)]), _ctx.registerLoading ? (_openBlock(), _createBlock(_component_registerLoad, {
    key: 3,
    type: "card",
    lockingStatus: _ctx.lockingStatus,
    registerStatus: _ctx.paymentStatus
  }, null, 8, ["lockingStatus", "registerStatus"])) : _createCommentVNode("", true)]);
}